import * as React from 'react';
import { VtxColumnProps } from '@vertexinc/vtx-ui-react-component-library';
import {
  DateFormatEnum,
  formatDateTime,
} from '@vcd-ecm-ui/Common';
import GridRowData from './GridRowData';

const columns: VtxColumnProps<GridRowData>[] = [
  {
    title: 'Last Occurrence',
    dataIndex: 'lastUpdateDateTimeStamp',
    render: (value, row: GridRowData, index: number) => (value
      ? formatDateTime(value, ' ', { dateFormat: DateFormatEnum.WMDY, month: 'short', dateSeperator: ' ' })
      : null),
    width: 230,
  },
  {
    title: 'Initial Occurrence',
    dataIndex: 'createDateTimeStamp',
    render: (value, row: GridRowData, index: number) => (value
      ? formatDateTime(value, ' ', { dateFormat: DateFormatEnum.WMDY, month: 'short', dateSeperator: ' ' })
      : null),
    width: 230,
  },
  {
    title: 'Error Message',
    dataIndex: 'message',
    className: 'reportColumnStyle',
    ellipsis: true,
  },
  {
    title: 'Action',
    dataIndex: 'action',
    width: 150,
    align: 'center',
    fixed: 'right',
  },
];

const getDefaultColumns = (): VtxColumnProps<GridRowData>[] => columns;

export default getDefaultColumns;
